// src/pages/ArticleDetailPage.jsx
import styled from 'styled-components';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SeoMeta from '../components/SeoMeta';
import { findArticleBySlug } from '../data/articles';
import { buildPageUrl, toAbsoluteUrl } from '../config/seo';

const Section = styled.main`
  padding: 84px 0 64px;
  .wrap{ width:${({theme})=>theme.container}; margin:0 auto; }
  .back { display:inline-block; margin-bottom: 12px; }
  h1 { margin: 0 0 10px; }
  .img { margin: 12px 0; }
  .img img { width:100%; max-height: 420px; object-fit:cover; border-radius: 12px; border:1px solid ${({theme})=>theme.border}; }
  .content { max-width: 900px; line-height:1.7; }
  .content h2, .content h3 { margin-top: 1.2rem; }
  .content ul { margin-left: 1.2rem; }
`;

export default function ArticleDetailPage() {
  const { slug } = useParams();
  const article = findArticleBySlug(slug);
  const { i18n } = useTranslation();

  if (!article) {
    return (
      <Section>
        <div className="wrap">
          <p>Статтю не знайдено. <Link to="/articles">Повернутись до списку.</Link></p>
        </div>
      </Section>
    );
  }

  const langCode = (i18n.resolvedLanguage || i18n.language || 'ua').slice(0, 2);
  const path = `/articles/${article.slug}`;
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: toAbsoluteUrl(article.image),
    mainEntityOfPage: buildPageUrl(path, langCode),
    inLanguage: langCode === 'en' ? 'en-US' : 'uk-UA',
    author: {
      '@type': 'Organization',
      name: 'MOMV',
    },
    publisher: {
      '@type': 'Organization',
      name: 'MOMV',
      logo: {
        '@type': 'ImageObject',
        url: toAbsoluteUrl('/logo.png'),
      },
    },
  };

  return (
    <Section>
      <SeoMeta
        title={`${article.title} — MOMV`}
        description={article.excerpt}
        image={article.image}
        path={path}
        structuredData={structuredData}
      />
      <div className="wrap">
        <Link className="back" to="/articles">← Повернутись до всіх статей</Link>
        <h1>{article.title}</h1>
        <div className="img"><img src={article.image} alt="" loading="lazy" /></div>
        <div className="content" dangerouslySetInnerHTML={{ __html: article.content }} />
      </div>
    </Section>
  );
}